export const removeAreaCodeFromPhoneNumber = (phoneNumber?: string): string => {
    if (!phoneNumber) return '';
    return phoneNumber.includes(' ') ? phoneNumber.split(' ')[1] : phoneNumber;
};

export const getAreaCode = (phoneNumber?: string): string => {
    if (!phoneNumber) return '';
    return phoneNumber.includes(' ') ? phoneNumber.split(' ')[0].slice(1) : '';
};
